var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.548828,
    y: 0.220703,
    width: 44,
    height: 44,
    rx: 10,
    fill: "#CDDCDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5986 23.2208H18.0766C18.2556 26.4896 19.3067 29.5261 21.0013 32.1017C16.5369 31.4079 13.0494 27.761 12.5986 23.2208ZM12.5986 21.2208C13.0494 16.6805 16.5369 13.0336 21.0013 12.3398C19.3067 14.9154 18.2556 17.9519 18.0766 21.2208H12.5986ZM32.4999 21.2208H27.0219C26.8429 17.9519 25.7918 14.9154 24.0972 12.3398C28.5616 13.0336 32.0491 16.6805 32.4999 21.2208ZM32.4999 23.2208C32.0491 27.761 28.5616 31.4079 24.0972 32.1017C25.7918 29.5261 26.8429 26.4896 27.0219 23.2208H32.4999ZM20.08 23.2208H25.0185C24.8469 26.0036 23.9639 28.594 22.5492 30.8123C21.1345 28.594 20.2516 26.0036 20.08 23.2208ZM20.08 21.2208C20.2516 18.4379 21.1345 15.8475 22.5492 13.6292C23.9639 15.8475 24.8469 18.4379 25.0185 21.2208H20.08Z",
    fill: "#3E414C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/Global.3b29b5b697989ad95215debfc788470d.svg";
export { ForwardRef as ReactComponent };